var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:[
    'sai-link',
    _vm.disable ? `disable text-${_vm.disableColor}` : `text-${_vm.color}`,
    {
      'sai-link--underlined': _vm.underlined
    }
  ],attrs:{"href":_vm.href,"target":_vm.target}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label || _vm.href))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }